import { render, staticRenderFns } from "./PopoverResponsavel.vue?vue&type=template&id=68bff5d9&scoped=true&"
import script from "./PopoverResponsavel.vue?vue&type=script&lang=ts&"
export * from "./PopoverResponsavel.vue?vue&type=script&lang=ts&"
import style0 from "./PopoverResponsavel.vue?vue&type=style&index=0&id=68bff5d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bff5d9",
  null
  
)

export default component.exports